import type { QueryClient } from '@tanstack/react-query';
import { growthKeys } from '@/data/queryKeys';
import type { CampaignListData } from '@/features/campaignlist/api';

/** Current month for period-scoped summary endpoints (`YYYY-MM`). */
export function defaultMarketingPeriod(date = new Date()): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
}

/**
 * Resolve a UI/route id to the marketing-api backend id.
 * List rows expose stable numeric ids; detail/summary/mutation paths need wire ids.
 */
export function resolveCampaignBackendId(
  queryClient: QueryClient,
  routeOrUiId: string | number,
): string {
  const raw = String(routeOrUiId);
  const numeric = Number(raw);
  if (!Number.isFinite(numeric)) return raw;

  const caches = queryClient.getQueriesData<CampaignListData>({
    queryKey: [...growthKeys.all, 'campaigns', 'list'],
  });
  for (const [, data] of caches) {
    const mapped = data?.idMap[numeric];
    if (mapped) return mapped;
  }
  return raw;
}
